module.exports = __webpack_public_path__ + "img/leisures-568x492.64bcee86.jpg";